<template>
    <component :is="tag">
        <slot
            :step="step"
            :brief="brief"
            :contact="contact"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-step="patchStep"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :is-patching-brief="isPatchingBrief"
            :errors="errors"
            :error-message="errorMessage"
            :hide-content-approval-onboarding="hideContentApprovalOnboarding"
            :context="context"
        />
    </component>
</template>

<script>
    import { NAME_TASKS } from '../../../constants/activation-brief-steps';
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import useContentApproval from '../../../../src/composables/use-content-approval';

    export default {
        name: 'ActivationBriefTasksProvider',
        mixins: [BaseActivationBriefStepMixin],
        computed: {
            step() {
                return this.steps[NAME_TASKS];
            }
        },
        data() {
            const context = this.$route.params.context;
            return {
                context
            };
        },
        methods: {
            hideContentApprovalOnboarding() {
                const { hideOnboarding } = useContentApproval();
                hideOnboarding(this.contact.id);
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([this.loadActivationBrief(true)]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch((error) => this.handleHttpError(error))
                .finally(() => {
                    this.isLoading = false;
                });
        }
    };
</script>
